import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'

import type { Styles } from '../../../theme/types/Styles'
import type { BijlageTemplateProject } from '../../types/BijlageTemplate'
import { formatAssignedTo } from '../../util'

const helperTexts = {
  isWerkvoorbereidingAannemer:
    'de netbeheerder extra werkvoorbereiding uitvoert',
  isCombiUitvoering: 'de discipline in combi uitvoert',
  isWerkvoorbereidingAannemerPerDiscipline:
    'de werkvoorbereiding uitgevoerd voor',
  isBetrokken: 'betrokken is op het project',
}

const HALF_WIDTH = 6
const FULL_WIDTH = 12

interface Props {
  bijlageTemplate: BijlageTemplateProject
  onClose: () => void
}

const disabledWithBlackText: Styles = {
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: 'black',
    color: 'black',
  },
}

export const BijlageTemplateConditional = ({
  bijlageTemplate,
  onClose,
}: Props) => {
  const { documentsoort, conditionalAssignedTo, assignedTo } = bijlageTemplate

  if (!conditionalAssignedTo) {
    return <></>
  }

  const {
    condition,
    thenAssignedTo,
    discipline,
    organisatie,
    elseAssignedTo,
    gebiedscodes,
  } = conditionalAssignedTo

  return (
    <Dialog maxWidth="md" fullWidth open>
      <DialogTitle>Conditionele toewijzing {documentsoort}</DialogTitle>
      <DialogContent>
        <TextField
          label="Conditie"
          value={condition}
          fullWidth
          sx={{
            mb: 2,
            mt: 2,
            ...disabledWithBlackText,
          }}
          disabled
        />
        <TextField
          label="Als"
          value={formatAssignedTo(thenAssignedTo)}
          helperText={helperTexts[condition]}
          fullWidth
          disabled
          sx={{ mb: 2, ...disabledWithBlackText }}
        />
        <Grid container spacing={1}>
          {discipline && (
            <Grid size={{ xs: organisatie ? HALF_WIDTH : FULL_WIDTH }}>
              <TextField
                label="Discipline"
                value={discipline}
                fullWidth
                sx={{ mb: 2, ...disabledWithBlackText }}
                disabled
              />
            </Grid>
          )}
          {organisatie && (
            <Grid size={{ xs: 6 }}>
              <TextField
                label="Organisatie"
                value={organisatie}
                fullWidth
                sx={{ mb: 2, ...disabledWithBlackText }}
                disabled
              />
            </Grid>
          )}
          {Array.isArray(gebiedscodes) && (
            <Grid size={{ xs: 12 }}>
              <TextField
                label="In gebieden"
                value={gebiedscodes.join(', ')}
                fullWidth
                sx={{ mb: 2, ...disabledWithBlackText }}
                disabled
              />
            </Grid>
          )}
          <Grid size={{ xs: 6 }}>
            <TextField
              label="Dan op naam van"
              value={formatAssignedTo(thenAssignedTo)}
              fullWidth
              sx={{ mb: 2, ...disabledWithBlackText }}
              disabled
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextField
              label="Anders op naam van"
              value={formatAssignedTo(elseAssignedTo || assignedTo)}
              fullWidth
              sx={{ mb: 2, ...disabledWithBlackText }}
              disabled
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Sluiten
        </Button>
      </DialogActions>
    </Dialog>
  )
}
